import { Injectable } from '@angular/core';
import { DataModel, replaceMultiple, ReservedWords } from '@shared';
import { mapKeys } from 'lodash';
import { ExportJSONFileModel } from '../models/export-file.model';
import { IExportSanitizer } from './export-sanitizer.interface';

@Injectable()
export class ExportSanitizerReservedWords implements IExportSanitizer {
	public sanitize(model: ExportJSONFileModel): ExportJSONFileModel {
		let needsToCheckInDataRecords = false;
		for (const entity of model.FusionEntities) {
			if (
				Object.values(ReservedWords.reservedWordsMap).some(
					(reservedWord: string) =>
						entity.entity_name.includes(reservedWord) || entity.primary_key.includes(reservedWord)
				)
			) {
				entity.entity_name = replaceMultiple(entity.entity_name, ReservedWords.reservedWordsMap);
				entity.primary_key = entity.primary_key.map((pk: string) =>
					replaceMultiple(pk, ReservedWords.reservedWordsMap)
				);
				needsToCheckInDataRecords = true;
			}
		}

		for (const column of model.FusionDataColumns) {
			if (
				Object.values(ReservedWords.reservedWordsMap).some((reservedWord: string) =>
					column.column_name.includes(reservedWord)
				)
			) {
				column.column_name = replaceMultiple(column.column_name, ReservedWords.reservedWordsMap);
				needsToCheckInDataRecords = true;
			}

			if (
				Object.values(ReservedWords.reservedWordsMap).some((reservedWord: string) =>
					column.table_name.includes(reservedWord)
				)
			) {
				column.table_name = replaceMultiple(column.table_name, ReservedWords.reservedWordsMap);
				needsToCheckInDataRecords = true;
			}
		}

		for (const table of model.FusionDataTables) {
			if (
				Object.values(ReservedWords.reservedWordsMap).some((reservedWord: string) =>
					table.table_name.includes(reservedWord)
				)
			) {
				table.table_name = replaceMultiple(table.table_name, ReservedWords.reservedWordsMap);
				needsToCheckInDataRecords = true;
			}
		}

		if (needsToCheckInDataRecords) {
			const newTableData: DataModel[] = [];
			for (const record of model.TABLE_DATA) {
				if (
					Object.values(ReservedWords.reservedWordsMap).some((reservedWord: string) =>
						record.table_name.includes(reservedWord)
					)
				) {
					record.table_name = replaceMultiple(record.table_name, ReservedWords.reservedWordsMap);
				}

				newTableData.push(
					mapKeys(record, (_, propertyName) => {
						if (
							Object.values(ReservedWords.reservedWordsMap).some((reservedWord: string) =>
								propertyName.includes(reservedWord)
							)
						) {
							propertyName = replaceMultiple(propertyName, ReservedWords.reservedWordsMap);
						}
						return propertyName;
					})
				);
			}

			model.TABLE_DATA = newTableData;
		}

		return model;
	}
}
